import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'entities/User';
import { Warehouse } from 'entities/Warehouse';
import { IssueInvoiceModalSchema, issuePersonalInvoiceSteps } from '../types';
import { Invoice, InvoiceItem } from 'entities/Invoice';
import { StepData } from 'features/Stepper';

const initialState: IssueInvoiceModalSchema = {
  isOpened: false,
  steps: issuePersonalInvoiceSteps,
  selectedUser: null,
  selectedWarehouse: null,
  invoiceData: null,
  invoiceItems: [],
};

const issueInvoiceModalSlice = createSlice({
  name: 'issueInvoiceModal',
  initialState,
  reducers: {
    setOpened: (state: IssueInvoiceModalSchema, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },
    changeStepData: (state: IssueInvoiceModalSchema, action: PayloadAction<{ targetStepIndex: number; stepData: string }>) => {
      state.steps = state.steps.map((step, index) =>
        index === action.payload.targetStepIndex ? { ...step, stepData: action.payload.stepData } : step,
      );
    },
    setSteps: (state: IssueInvoiceModalSchema, action: PayloadAction<StepData[]>) => {
      state.steps = action.payload;
    },
    setSelectedUser: (state: IssueInvoiceModalSchema, action: PayloadAction<User>) => {
      state.selectedUser = action.payload;
    },
    setSelectedWarehouse: (state: IssueInvoiceModalSchema, action: PayloadAction<Warehouse>) => {
      state.selectedWarehouse = action.payload;
    },
    setInvoiceData: (state: IssueInvoiceModalSchema, action: PayloadAction<Partial<Invoice>>) => {
      state.invoiceData = action.payload;
    },
    setInvoiceItems: (state: IssueInvoiceModalSchema, action: PayloadAction<InvoiceItem[]>) => {
      state.invoiceItems = action.payload;
    },
    resetModalState: (state: IssueInvoiceModalSchema) => {
      state.steps = issuePersonalInvoiceSteps;
      state.selectedUser = null;
      state.selectedWarehouse = null;
      state.invoiceData = null;
      state.invoiceItems = [];
      state.isOpened = false;
    },
  },
});

export const { actions: issueInvoiceModalActions, reducer: issueInvoiceModalReducer } = issueInvoiceModalSlice;
